import preloaderHtmlTemplate from "./Preloader.ejs"
import makeTemplateFunc from "lodash/template"
import Promise from "promise-polyfill"

import "./Preloader.css";

const preloaderTemplateFunc = makeTemplateFunc(preloaderHtmlTemplate);

export class Preloader {
  constructor($container) {
    this.$container = $container;
    this.$preloader = $(preloaderTemplateFunc());
    this.requestCount = 0;
  }

  show() {
    this.requestCount += 1;
    this.$container.after(this.$preloader);
  }

  hide() {
    this.requestCount -= 1;

    if (!this.requestCount) {
      this.$preloader.detach();
    }
  }

  showWhile(promise) {
    this.show();

    return new Promise((resolve, reject) => {
      promise
        .then((data) => {
          this.hide();
          resolve(data);
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./js/components/Preloader/Preloader.js